import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=440c7ad4&scoped=true&"
import script from "./SideMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SideMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenuItem.vue?vue&type=style&index=0&id=440c7ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440c7ad4",
  null
  
)

component.options.__file = "SideMenuItem.vue"
export default component.exports